import { getDaysInMonth } from 'app/lib/date';
import type { UserMonthlyStatsResponseDTO } from 'app/network/monthly-stats';

export interface NetworkStatus {
  period: string;
  targetM: number;
  confirmedTotal: number;
  streakAchieved: boolean;
  individualConfirmedTotal: number;
}

export type HistoryMonth = Pick<
  UserMonthlyStatsResponseDTO,
  'period' | 'numUsersTarget' | 'targetMultiplier' | 'numLoans' | 'isFreeze'
>;

export interface NetworkSavings {
  period: string;
  totalEstimatedPrice: number;
}

export function dtoToStatus(dto: UserMonthlyStatsResponseDTO): NetworkStatus {
  const targetM = Math.round(dto.numUsersTarget * dto.targetMultiplier);
  return {
    period: dto.period,
    targetM,
    confirmedTotal: dto.numLoans,
    streakAchieved: dto.numLoans >= targetM,
    individualConfirmedTotal: dto.numMyLoans,
  };
}

export function dtoToSavings(dto: UserMonthlyStatsResponseDTO): NetworkSavings {
  return {
    period: dto.period,
    totalEstimatedPrice: dto.totalEstimatedPrice,
  };
}

export const computeDaysRemainingInMonth = (date: Date): number => {
  return Math.max(0, getDaysInMonth(date) - date.getDate() + 1);
};

export const STREAK_TOTAL_DAYS = 7;
export const NEIGHBOURHOOD_FIRST_SHARE_PERCENT = 40;

export const todayDateString = (): string => {
  const now = new Date();
  const yyyy = String(now.getFullYear());
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};
